(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  (function () {
    const banner = document.getElementById('cookie-consent-banner');
    const acceptBtn = document.getElementById('cookie-consent-accept');
    const declineBtn = document.getElementById('cookie-consent-decline');

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function hideBanner() {
      banner.classList.remove('is-visible');
      if (reducedMotion) {
        banner.hidden = true;
      } else {
        banner.addEventListener('transitionend', function () {
          banner.hidden = true;
        }, { once: true });
      }
    }

    function showBanner() {
      banner.hidden = false;
      if (reducedMotion) {
        banner.classList.add('is-visible');
      } else {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            banner.classList.add('is-visible');
          });
        });
      }
    }

    function acceptConsent() {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);
      } else {
        hideBanner();
      }
    }

    function declineConsent() {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(false, hideBanner);
      } else {
        hideBanner();
      }
    }

    function initBanner() {
      if (!window.Shopify || !window.Shopify.customerPrivacy) {
        showBanner();
        return;
      }

      var needsConsent =
        window.Shopify.customerPrivacy.shouldShowGDPRBanner() ||
        window.Shopify.customerPrivacy.shouldShowCCPABanner();

      if (needsConsent) {
        showBanner();
      }
    }

    acceptBtn.addEventListener('click', acceptConsent);
    declineBtn.addEventListener('click', declineConsent);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBanner);
    } else {
      initBanner();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
